import { SmsCampaignInfo } from 'interface/WizardV3';

export function getApprovedSPCarrier(smsCampaignInfo: SmsCampaignInfo) {
  const approvedCarrier = smsCampaignInfo?.data?.find(
    (campaign) =>
      campaign.campaignStatus === 'ACCEPTED' && campaign.campaignId !== null,
  );
  const isApprovedSPCarrier =
    approvedCarrier?.corpAcctType === 'SOLE_PROPRIETOR';
  return { carrier: approvedCarrier?.smsCarrier, isApprovedSPCarrier };
}
